<template>
    <div class="shrink-0 px-3 pb-3">
        <div class="journeys-workflow-footer flex flex-wrap items-center justify-between gap-3 rounded-xl bg-ink px-5 py-4 text-ink-inverse">
            <div class="flex min-w-0 flex-col gap-1">
                <p class="body-semibold" aria-live="polite">{{ title }}</p>
                <p class="body-small text-ink-inverse/80">{{ description }}</p>
            </div>
            <JourneyButton
                :data-testid="testId"
                theme="inverse"
                size="md"
                class="shrink-0"
                :disabled="disabled || isSubmitting"
                :aria-busy="isSubmitting"
                @click="emit('continue')">
                {{ isSubmitting ? "Saving…" : actionLabel }}
            </JourneyButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import JourneyButton from "~vue/pages/developmentJourneys/DevelopmentJourneyButton.vue";

defineProps<{
    title: string;
    description: string;
    actionLabel: string;
    testId: string;
    disabled: boolean;
    isSubmitting: boolean;
}>();

const emit = defineEmits<{
    continue: [];
}>();
</script>
